/**
 * @function getCoords
 * @description Координаты элемента
 *
 * @param {HTMLElement} elem - проверяемый элемент
 */
function getCoords(elem) {

    let box = elem.getBoundingClientRect();
    return {
        top:box.top + window.scrollY,
        right:box.right + window.scrollX,
        bottom:box.bottom + window.scrollY,
        left:box.left + window.scrollX,
        height:box.height,
    };
}

/**
 * @function isOnScreen
 * @description Эта функция проверяет, находится ли заданный элемент в данный момент в видимой области окна веб-страницы.
 *
 * @param {HTMLElement} elem - проверяемый элемент
 * @param {number|null} coefficientDesktop - Число, которое регулирует точку срабатывания функции на настольных устройствах. Чем выше значение, тем дальше от области просмотра будет считаться, что элемент "на экране".
 * @param {number|null} coefficientMobile - Число, которое регулирует точку срабатывания функции на мобильных устройствах. Чем выше значение, тем дальше от области просмотра будет считаться, что элемент "на экране".
 *
 */
function isOnScreen(elem, coefficientDesktop = null, coefficientMobile = null) {
    // Если коэффициенты не предоставлены, используем значения по умолчанию
    if (coefficientDesktop === null && coefficientMobile === null) {
        let coefficient;
        // Используем более высокий коэффициент (0.75) для мобильных устройств
        window.innerWidth <= 768 ? coefficient = 0.75 : coefficient = 0.3;
        return window.scrollY > (getCoords(elem).top - window.innerHeight / coefficient);
    } else {
        // Используем предоставленные коэффициенты
        if (window.innerWidth <= 768) {
            return window.scrollY > (getCoords(elem).top - window.innerHeight / coefficientMobile);
        } else {
            return window.scrollY > (getCoords(elem).top - window.innerHeight / coefficientDesktop);
        }
    }
}

/**
 * @function isMobile
 * @description Проверка ширины устройства (мобильный или десктоп)
 */
function isMobile() {

    return window.outerWidth <= 768;
}

/**
 * @function isExist
 * @description Проверка наличия элемента на странице
 *
 * @param {string} selector - проверяемый элемент
 */
function isExist(selector) {

    return document.querySelector( selector );
}

/**
 * @function isHome
 * @description Проверка, является ли текущая страница главной
 */
function isHome() {

    return isExist( '.home' );
}

/**
 * @function initPhoneMask
 * @description Маска телефона: +9 (999) 999-9999
 *
 * @param {HTMLInputElement} input
 */
function initPhoneMask( input ) {
	const formatPhoneValue = ( digits ) => {
		if ( !digits.length ) {
			return '';
		}

		let formatted = '+' + digits.slice( 0, 1 );

		if ( digits.length > 1 ) {
			formatted += ' (' + digits.slice( 1, 4 );
		}

		if ( digits.length >= 4 ) {
			formatted += ') ' + digits.slice( 4, 7 );
		}

		if ( digits.length >= 7 ) {
			formatted += '-' + digits.slice( 7, 11 );
		}

		return formatted;
	};

	const getDigits = ( value ) => value.replace( /\D/g, '' ).slice( 0, 11 );

	input.addEventListener( 'input', () => {
		input.value = formatPhoneValue( getDigits( input.value ) );
	} );

	input.addEventListener( 'focus', () => {
		if ( !input.value ) {
			input.value = '+';
		}
	} );

	input.addEventListener( 'blur', () => {
		if ( input.value === '+' ) {
			input.value = '';
		}
	} );
}
